import { Link } from "react-router-dom";
import { FaBars, FaTimes } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext.js';
import { useRef } from "react";
import { getRoute } from "../utils/getRoute.js";

export default function Header() {
    const navBar = useRef();
    const ShowNavBar = () => {
        navBar.current.classList.toggle("responsive-nav");
    };
    const { t, language, setLanguage } = useLanguage();
    return (
        <div className="header-container" style={{ direction: language === 'en' ? 'ltr' : 'rtl' }}>
            <Link to="/">
                <h1 className="logo-text">MP <span>Technology</span></h1>
            </Link>
            <div>
                <ul className="header-list" ref={navBar}>
                    <li><Link to={getRoute('home', language)}>{t('header.home')}</Link></li>
                    <li><Link to={getRoute('about', language)}>{t('header.about')}</Link></li>
                    <li><Link to={getRoute('service', language)}>{t('header.our_services')}</Link></li>
                    <li><Link to={getRoute('projects', language)}>{t('header.our_works')}</Link></li>
                    <li><a href="https://mptechnology1.blogspot.com/" target="_blank" rel="noopener noreferrer">{t('header.plag')}</a></li>
                    <li><a href="#" onClick={() => setLanguage(language === 'en' ? 'ar' : 'en')}>{language === 'en' ? 'AR' : 'EN'}</a></li>
                    <li><FaTimes className="nav-btn nav-btn-close" onClick={ShowNavBar} /></li>
                </ul>
            </div>
            <div>
                <button className="nav-btn" onClick={ShowNavBar}><FaBars /></button>
                <Link to={getRoute('contact', language)}>
                    <button className="btn contact-btn" style={{ marginRight: language === 'en' ? '10px' : '0px', marginLeft: language === 'en' ? '0' : '10px' }}>
                        {t('header.btn_contact_us_text')}
                    </button>
                </Link>
                <a href="https://wa.me/+966557380850" target="_blank" rel="noopener noreferrer">
                    <button className="btn order-btn">{t('header.btn_sevice_request')}</button>
                </a>
            </div>
        </div>
    );
}